import { environment } from "environments/environment";

export class HttpUtils {
    public static getBaseUrl(): string {
       if (process.env.ENV === 'production') {
            if(environment.loadedInVCRemotePlugin) {
                let path = (window.location.pathname.match(/(.*)(\/hcx)(\/.*|$)/) || [])[1];
                return path + '/hcx-ui/rest';
            }else {
                return '';
            }
       }
       return '/vsphere-client/hcx/hcx-ui/rest';
    }
}



// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/utils/http-utils.ts